import PowerUp = Trello.PowerUp;
import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { Trello } from 'types/trello';

@Component({
  template: ``
})
export class BoardButtonCallbackComponent implements OnInit {

  static readonly buttonDarkBackgroundIcon = `${environment.webOrigin}/assets/chart-line-white.svg`;
  static readonly buttonLightBackgroundIcon = `${environment.webOrigin}/assets/chart-line-black.svg`;
  static readonly buttonText = 'Intellect';
  static readonly panelHeight = 800;
  static readonly panelTitle = 'Intellect';
  static readonly panelUrlPath = environment.paths.onboarding;

  ngOnInit(): void {

    window.TrelloPowerUp.initialize(
      {
        'board-buttons': function (trello: PowerUp.IFrame) {
          return [
            {
              text: BoardButtonCallbackComponent.buttonText,
              icon: {
                dark: BoardButtonCallbackComponent.buttonDarkBackgroundIcon,
                light: BoardButtonCallbackComponent.buttonLightBackgroundIcon,
              },

              callback: async (trello: PowerUp.IFrame) => {

                await trello.modal({
                  height: BoardButtonCallbackComponent.panelHeight,
                  title: BoardButtonCallbackComponent.panelTitle,
                  url: BoardButtonCallbackComponent.panelUrlPath,
                  fullscreen: true,
                  args: {},
                });
              }
            },
          ];
        },
      },
      {
        appKey: environment.appKey,
        appName: environment.appName,
      }
    );
  }

}
